export default __webpack_public_path__ + "static/media/icon-calendar.a8fe7fb0.svg";